import {Component, OnInit} from '@angular/core';

@Component({
	selector: 'k-table-footer',
	templateUrl: './table-footer.component.html',
	styleUrls: ['./table-footer.component.scss']
})
export class TableFooterComponent implements OnInit {

	constructor() {
	}

	ngOnInit(): void {
	}

}
